/* 🤖 this file was generated by svg-to-ts */
export const matIconDataUsage: {
  name: 'data-usage';
  data: string;
} = {
  name: 'data-usage',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0 1 12 19z"/></svg>`
};
